import React from "react";

const NotFound = () => {
  return (
    <div>
      <h2>This page not found</h2>
    </div>
  );
};

export default NotFound;
